
	import Component from 'vue-class-component'
	import moduleStore from './store/realFreeAudition';
	import Vue from 'vue';
	import PageState from './store/state';
	import { getQueryString } from '@/utils/location'
	import { customCollectEvent } from '@/utils/collect';

	/**components**/
	@Component({})
	@moduleStore.initVuex({
		mutationNames:moduleStore.mutationNames,
		actionNames:moduleStore.actionNames
	})
	export default class realFreeAuditionPage extends Vue implements IvuePage<PageState>{
		state = new PageState();
		self:Vue = this;
		promottype:any = null;
		isRealVoiceMini:Boolean = false;
		created(moduleData:IinjectDatas) {
			this.state = <PageState>moduleData.state;
			let from = getQueryString('from')
			if(from=='realVoiceMini'){  //从小程序过来
				this.isRealVoiceMini = true
			}
		}
		mounted(moduleData:IinjectDatas){	
			this.state.title="这是更改后的title"
			this.state.self = this;
		}
		toCustomerPage(){
			try {
				customCollectEvent('livevoice_qrcode')
			} catch (error) {
				console.log(error);
			}
			if(this.isRealVoiceMini){  //从小程序过来
				let origin = location.origin
    			let url = `${origin}/#/realVoiceCustomer`;
				wx.miniProgram.navigateTo({url: `/pages/webview/webview?url=${url}&nav=真人配音&from=realVoiceMini`});
			}else{
				this.$router.push({path: '/realVoiceCustomer'})
			}

		}
	
	}